// extracted by mini-css-extract-plugin
module.exports = {"messageCTA":"styles_messageCTA__36315","messageCTAIcon":"styles_messageCTAIcon__aZp5r","messageCTAText":"styles_messageCTAText__38Nki"};